export const yaTidakFlagOptions = [
  {
    value: false,
    title: 'Tidak',
  },

  {
    value: true,
    title: 'Ya',
  },
];

export const yaBukanFlagOptions = [
  {
    value: false,
    title: 'Bukan',
  },
  {
    value: true,
    title: 'Ya',
  },
];

export const productCategories = [
  {
    value: 'JASA',
    title: 'Jasa',
  },
  {
    value: 'TITIP BAYAR',
    title: 'Titip Bayar',
  },
];

export const taxCalculationMethods = [
  {
    value: 'ADD',
    title: 'Add ( ➕ )',
    icon: 'mdi-plus',
    color: 'green-darken-2',
  },
  {
    value: 'DEDUCT',
    title: 'Deduct ( ➖ )',
    icon: 'mdi-minus',
    color: 'red-darken-2',
  },
];
